import { useEffect, useRef, useState } from 'react';

export function useSpeechInput(value: string, onChange: (value: string) => void, onError: (message: string) => void) {
  const recognition = useRef<SpeechRecognition | null>(null);
  const [recording, setRecording] = useState(false);

  useEffect(() => () => recognition.current?.stop(), []);

  function toggle() {
    if (recognition.current) return recognition.current.stop();
    const Constructor = window.SpeechRecognition ?? window.webkitSpeechRecognition;
    if (!Constructor) return onError('Talegjenkjenning støttes ikke her — skriv svaret i stedet.');
    const instance = new Constructor();
    recognition.current = instance;
    instance.lang = 'nb-NO';
    instance.interimResults = true;
    instance.continuous = true;
    let finalTranscript = value ? `${value} ` : '';
    instance.onstart = () => setRecording(true);
    instance.onresult = event => {
      let interim = '';
      for (let index = event.resultIndex; index < event.results.length; index += 1) {
        const result = event.results[index];
        if (result.isFinal) finalTranscript += `${result[0].transcript} `;
        else interim += result[0].transcript;
      }
      onChange(`${finalTranscript}${interim}`.trim());
    };
    instance.onerror = () => onError('Vi fikk ikke tilgang til mikrofonen.');
    instance.onend = () => {
      recognition.current = null;
      setRecording(false);
    };
    instance.start();
  }

  return { recording, toggle, supported: Boolean(window.SpeechRecognition ?? window.webkitSpeechRecognition) };
}
